<template>
  <div class="home">
    <el-container>
      <!-- 左边菜单导航 -->
      <el-aside width="none">
        <el-menu
          style="height: 100%"
          :default-active="$route.path"
          class="el-menu-vertical-demo"
          background-color="#545c64"
          text-color="#fff"
          active-text-color="#ffd04b"
          router
          unique-opened
        >
          <!-- logo -->
          <div class="menu-logo" @click="getHome">
            <img :src="logoUrl" />
          </div>

          <!-- 左菜单 -->
          <!-- 第一个循环 -->
          <el-submenu
            v-for="(item, index) in navmenu"
            :key="index"
            :index="item.title"
          >
            <template slot="title">
              <i :class="item.icon" style="color: #fff; "></i>
              <span slot="title">{{ item.title }}</span>
            </template>
            <!-- 第二个循环 -->
            <el-menu-item-group>
              <el-menu-item
                v-for="(itm, idx) in item.url"
                :key="idx"
                :index="itm.link"
                style="font-size: 12px"
                ><i class="el-icon-menu"></i>{{ itm.name }}</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-container>
        <el-header>
          <!-- 搜索 -->
          <div class="queryOrder">
            <el-input
              placeholder="请输入运单号"
              size="small"
              v-model="input"
              clearable
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="toOrderDetails"
              ></el-button>
            </el-input>
          </div>
          <!-- 公告栏滚动 -->
          <div class="textBox">
            <el-carousel
              height="70px"
              indicator-position="none"
              direction="vertical"
              :autoplay="true"
            >
              <el-carousel-item v-for="item in msgData" :key="item.id">
                <h3 class="medium" @click="showMsg(item.id)">
                  {{item.createTime | dateformat("YYYY年MM月DD日")}}：{{ item.title }}
                </h3>
              </el-carousel-item>
            </el-carousel>
          </div>
          <!-- 退出 -->
          <div class="sinout" @click="sinout()">
            <i class="el-icon-switch-button"></i>
            退出
          </div>
          <!-- 公司 -->
          <div class="user" @click="getHome">
            <i class="el-icon-s-custom"></i>{{ this.user }}
          </div>
        </el-header>
        <el-main>
          <router-view />
        </el-main>
      </el-container>
    </el-container>


<!-- 公告详情弹框 -->
        <el-dialog
          :title="msgTitle"
          :visible.sync="msgDialogVisible"
        >
          <div v-html="msgContent">{{ msgContent }}</div>
        </el-dialog>
        

  </div>
</template>

<script>
//引入api
import httpApi from "@/http/api";

export default {
  name: "Home",
  data() {
    return {
      navmenu: [
        {
          title: "订单管理",
          url: [
            // { link: "/expressorder", name: "快递下单" },            
            { link: "/products", name: "产品管理" },
            { link: "/orderby2", name: "新建订单" },
            { link: "/myorder", name: "我的订单" },
          ],
          icon: "el-icon-folder-checked",
        },
        {
          title: "财务结算",
          url: [{ link: "/radingcenter", name: "交易记录" }],
          icon: "el-icon-money",
        },
        {
          title: "会员中心",
          url: [
            { link: "/supplier", name: "供应商管理" },
            { link: "/managementdef", name: "进口商管理" },
            { link: "/shippermanagement", name: "发货人管理" },
            { link: "/account", name: "账号管理" },
            { link: "/changepass", name: "修改密码" },
            { link: "/message", name: "公告" },
          ],
          icon: "el-icon-user",
        },
      ],
      input: "",
      user: "",
      msgData: [],
      msgTitle: "",
      msgDialogVisible: false,
      msgContent: "",
      logoUrl: "",
    };
  },
  methods: {
    //去往首页
    getHome() {
      this.$router.push("/");
    },
    //退出
    sinout() {
      sessionStorage.removeItem("token");
      localStorage.removeItem("refToken");
      this.$router.push("/login");
    },
    //获取公司
    getuser() {
      httpApi.getUser().then((res) => {
        if (res.data.code == "ok") {
          this.user = res.data.data.company;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    init() {
      let that = this;
      httpApi
        .listParams({
          params: {
            type: "sys_config",
            enable: "1",
          },
        })
        .then((res) => {
          if (res.data.code == "ok") {
            that.logoUrl = res.data.data[0].logoPortalUrl;
          }
        });
    },
    //搜索详情页
    toOrderDetails() {
      let that = this;
      let time = new Date().getTime();
      if (that.input) {
        httpApi.search({ params: { clientNo: that.input } }).then((res) => {
          if (res.data.code == "ok") {
            that.$router.push(
              "/orderdetails/" + res.data.data.findOrderResponse.orderNo
            );
          } else {
            that.$message.error(res.data.message);
          }
        });
      }
    },
    //获取公告栏消息
    findMsg() {
      let that = this;
      httpApi
        .queryMsg({
          params: {
            page: 1,
            rows: 10,
            hasread: "",
            type: "1",
          },
        })
        .then((res) => {
          if (res.data.code == "ok") {
            that.msgData = res.data.data.rows;
          } else {
            that.$message.error(res.data.message);
          }
        });
    },
    //点击公告栏
    showMsg(msgId) {
      const msg = this.msgData.filter((value) => {
        return value.id === msgId;
      })[0];
      this.msgDialogVisible = true;
      this.msgTitle = msg.title;
      this.msgContent = msg.content;
    },
  },
  created() {
    this.init();
    this.getuser();
    this.findMsg();
  },
};
</script>

<style lang="less" scoped>
// 布局容器
.home {
  width: 100%;
  height: 100%;
  position: absolute;
}
.el-container {
  height: 100%;
  width: 100%;
}
.el-header,
.el-footer {
  background-color: #b3c0d1;
  color: #333;
  text-align: center;
  line-height: 60px;
}
.el-main {
  width: auto;
  min-width: 1000px;
  background-color: #fff !important;
  padding: 15px;
}
.el-aside {
  background-color: #545c64;
  color: #333;
  // text-align: center;
  line-height: 200px;
  height: 100%;
  /deep/ .menu-logo {
    cursor: pointer;
    height: 70px;
    background-color: #fff;
    display: flex;
    img {
      margin: auto;
      height: 80%;
      width: auto;
    }
  }
  /deep/.el-menu-item-group__title {
    padding: 3px 0 3px 20px;
  }
  /deep/.el-submenu__title {
    padding: 0 60px 0 0px;
    /deep/.el-icon-menu {
      padding: 0 15px 0 0px;
    }
  }
  /deep/.el-menu {
    border-right: none;
  }
}
/deep/.el-submenu .el-menu-item {
  min-width: 180px !important;
}
.el-header {
  background: url("../assets/bg1.png") no-repeat 100% 100%;
  height: 70px !important;
  line-height: 70px;
  .sinout {
    float: right;
    width: 50px;
    cursor: pointer;
    text-align: center;
    color: #fff;
    i {
      font-size: 14px;
      line-height: 70px;
      // font-weight: bold;
    }
  }
  .queryOrder {
    float: left;
    width: 200px;
    margin-left: 10px;
  }
  .user {
    margin-right: 10px;
    width: 250px;
    float: right;
    text-align: right;
    font-size: 14px;
    cursor: pointer;
    color: white;
    height: 70px;
    overflow: hidden;
    i {
      font-size: 14px;
    }
  }
  .textBox {
    width: 470px;
    height: 70px;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
    text-align: left;
    float: left;
    margin-left: 50px;
    color: #fff;
    h3 {
      cursor: pointer;
    }
  }
}
</style>
